import { render, staticRenderFns } from "./InstitutionalPageSyncButton.vue?vue&type=template&id=8c775a14&scoped=true"
import script from "./InstitutionalPageSyncButton.vue?vue&type=script&lang=js"
export * from "./InstitutionalPageSyncButton.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalPageSyncButton.vue?vue&type=style&index=0&id=8c775a14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c775a14",
  null
  
)

export default component.exports